const themeTable = () => import('@/views/main/dataList/themeTable.vue')
export default {
  path: '/main/dataList/themeTable',
  name: 'themeTable',
  component: themeTable,
  children: []
}
